import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";

const EVENTS = [
  {
    name: "Cyb2r Days",
    start: new Date("2025-07-07T00:00:00-05:00"),
    end: new Date("2025-07-10T23:59:59-05:00"),
    highlight: "Del 7 al 10 de Julio",
    description: null,
    wsp_message: "¡Hola! Deseo información del Cyb2r Days",
  },
  {
    name: "Cyb2r Wow",
    start: new Date("2025-07-14T00:00:00-05:00"),
    end: new Date("2025-07-17T23:59:59-05:00"),
    highlight: "Del 14 al 17 de Julio",
    description: null,
    wsp_message: "¡Hola! Deseo información del Cyb2r Wow",
  },
  {
    name: "CYb2R Rojo y Blanco",
    start: new Date("2025-07-28T00:00:00-05:00"),
    end: new Date("2025-07-31T23:59:59-05:00"),
    highlight: "ÚLTIMA OPORTUNIDAD",
    description: "Del 28 al 31 de Julio",
    wsp_message: "¡Hola! Deseo información del CYb2R Rojo y Blanco",
  }
];

export default function PromoToast() {
  const [show, setShow] = useState(true);
  const location = useLocation();
  const currentEvent = useMemo(() => {
    const today = new Date();
    return EVENTS.find((event) => today >= event.start && today <= event.end);
  }, []);

  const shouldShowPromo = useMemo(() => {
    return location.pathname === "/" && show && currentEvent;
  }, [location.pathname, show, currentEvent]);

  return (
    <>
      {shouldShowPromo && (
        <div
          className="promo-toast tw-rounded-xl filter-shadow-embossed"
          style={{ textWrap: "nowrap" }}
        >
          <button
            className="tw-absolute tw-top-2 tw-right-2 tw-text-black tw-text-2xl tw-font-bold tw-bg-transparent tw-border-none tw-cursor-pointer"
            onClick={() => setShow(false)}
          >
            <i className="bi bi-x"></i>
          </button>
          <div className="tw-w-full tw-py-6 tw-px-6 tw-overflow-x-auto">
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-md tw-font-semibold tw-text-primary tw-ps-2">
                {currentEvent ? currentEvent.highlight : ""}
              </span>
              <span className="tw-font-extrabold text-primary md:tw-text-6xl tw-text-4xl">
                {currentEvent ? currentEvent.name : ""}
              </span>
              <div className="tw-flex tw-flex-col tw-mb-3">
                <span className="tw-text-sm">
                  {currentEvent ? currentEvent.description : ""}
                </span>
              </div>
              <div className="tw-h-full">
                <a
                  href={`https://api.whatsapp.com/send?phone=51938079688&text=${encodeURIComponent(
                    currentEvent ? currentEvent.wsp_message : ""
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                  className="tw-bg-black tw-text-white tw-font-bold tw-text-lg tw-py-2 tw-px-3 tw-rounded-lg tw-transition tw-duration-300 tw-ease-in-out tw-transform tw-hover:tw-opacity-80"
                >
                  INFO AQUÍ
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
